import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";
import SuccessMessage from "../common/Message";
import SearchLocationInput from "./GooglePlcasesApi";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

function Jobupdate() {
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const viewId = useParams();
  const jobId = viewId.jobid;
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [isEndDate, setIsEndDate] = useState(false);
  const [isStartDate, setIsStartDate] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);
  const [feedbackCreator, setFeedbackCreator] = useState([]);
  const [feedbackProvider, setFeedbackProvider] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [industries, setIndustries] = useState([]);
  // const [selectedValue, setSelectedValue] = useState(""); // Set initial selected value here
  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: " ",
  });
  // const [industryValue, setIndustryValue] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsCategory, setSelectedOptionsCategory] = useState([]);
  const [selectedOptionsSubCategory, setSelectedOptionsSubCategory] = useState([]);

  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const handleChange = (value) => {
    const data = [...selectedOptions];
    const select = parseInt(value.target.value);
    if (data.includes(select)) {
      setSelectedOptions(data.filter((item) => item !== select));
    } else {
      setSelectedOptions([...selectedOptions, select]);
    }
  };
  const handleChangeCategory = (value) => {
    const data = [...selectedOptionsCategory];
    const select = parseInt(value.target.value);
    if (data.includes(select)) {
      setSelectedOptionsCategory(data.filter((item) => item !== select));
    } else {
      setSelectedOptionsCategory([...selectedOptionsCategory, select]);
    }
  };

  const handleChangeSubCategory = (value) => {
    const data = [...selectedOptionsSubCategory];
    const select = parseInt(value.target.value);
    if (data.includes(select)) {
      setSelectedOptionsSubCategory(data.filter((item) => item !== select));
    } else {
      setSelectedOptionsSubCategory([...selectedOptionsSubCategory, select]);
    }
  };
  useEffect(() => {
    viewJobDetailsUpdated();
    
    getsubcategorylist();
  }, []);

  const getsubcategorylist = async () => {
      try {
        const res_category = await fetch(`${apiUrl}/admin/subcategorylist`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        const data_category = await res_category.json();
        if (data_category.status !== 200) {
          throw new Error("Data not found");
        }
        
        setSubCategoryList(data_category.data);
        setCategoryList(data_category.categorylist);
        setIndustries(data_category.industrylist);

      } catch (error) {
        console.error("Error ", error);
      }
  };
  // date
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };
  const datefunction = (dateValue, dateType) => {
    const getDate = dateValue;
    const strgetDate = `${getDate}`;
    const arrDate = strgetDate.split(" ");
    const completeStartDate =
      arrDate[3] +
      "-" +
      months[arrDate[1]] +
      "-" +
      arrDate[2] +
      " " +
      arrDate[4];
    if (dateType === "startdate") {
      setStartDate(completeStartDate);
      setIsStartDate(true);
    } else {
      setEndDate(completeStartDate);
      setIsEndDate(true);
    }
  };
  // date

  const updatejob = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    // console.log(data);
    // return
    const latValue = selectedLocation.lat;
    const longValue = selectedLocation.lng;
    const addressValue = selectedLocation.address;
    const userId = items.userId;
    const title = data.get("title");
    const desc = data.get("desc");
    const positions = data.get("positions");
    const specialism = data.get("specialism");
    const information = data.get("informations");
    const city = data.get("city");
    const postcode = data.get("postcode");
    const date = data.get("date");
    const time = data.get("time");
    const start_date = isStartDate ? startDate: null;
    const end_date = isEndDate ? endDate: null;

    const updatedemp = {
      jobid: jobId,
      title: title,
      description: desc,
      positions: positions,
      specialism: specialism,
      information: information,
      city: city,
      postcode: postcode,
      created_at: date + " " + time,
      address: addressValue,
      longitude: longValue,
      latitude: latValue,
      industry: selectedOptions,
      category: selectedOptionsCategory,
      subcategory: selectedOptionsSubCategory,
      start_date: start_date,
      end_date: end_date,
      
    };
    // console.log(updatedemp);
    // return
    const providerresult = await fetch(`${apiUrl}/admin/updateJobAdmin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(updatedemp),
    });
    const updatedData = await providerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
    viewJobDetailsUpdated();
  };
  const viewJobDetailsUpdated = async () => {
    const postData = {
      jobid: jobId,
    };
    const res = await fetch(`${apiUrl}/admin/viewjobdetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(postData),
    });
    const data = await res.json();
    if (data.status !== 200) {
      throw new Error("Data not found");
    }
    setItems(data.data);
    const industry = await [...data.data.industry];
    await setSelectedOptions(...selectedOptions, industry);
    
    const category = await [...data.data.category];
    await setSelectedOptionsCategory(...selectedOptionsCategory, category);

    const subCategory = await [...data.data.subcategory];
    await setSelectedOptionsSubCategory(...selectedOptionsSubCategory, subCategory);
    setSelectedLocation({
      lat: data.data.latitude,
      lng: data.data.longitude,
    })
    setFeedbackCreator(data.data.feedback_creator);

    setFeedbackProvider(data.data.feedback_provider);

    setSelectedOption(data.data.status);
    // setSelectedValue(data.data.jobIndustry.industry_id);
    
    setSelectedOptions(data.data.industry);
    setSelectedOptionsCategory(data.data.category);
    setSelectedOptionsSubCategory(data.data.subcategory);

    const startdateItem = data.data.start_date;
    const enddateItem = data.data.end_date;
    setStartDate(startdateItem);
    setEndDate(enddateItem);
    getsubcategorylist();
  }
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleSuccessMessageFadeOut = async () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    // window.location.reload();
  };
  const changeFeedback = async (params, e, index) => {
    console.log(params.target.value, e, index);
    const data = [...feedbackCreator];
    data[index].feedback = params.target.value;
    setFeedbackCreator(data);
    const res = await fetch(`${apiUrl}/admin/update_feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id:data[index].id,
        feedback:data[index].feedback
      }),
    });
    // const updatedData = await res.json();
    
  }
  const changeProviderFeedback = async (params, e, index) => {
    console.log(params.target.value, e, index);
    const data = [...feedbackCreator];
    data[index].feedback = params.target.value;
    setFeedbackProvider(data);
    const res = await fetch(`${apiUrl}/admin/update_feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id:data[index].id,
        feedback:data[index].feedback
      }),
    });
    // const updatedData = await res.json();
    
  }
  return (
    <div className="width90">
      <h2 className="pageTitle">Edit Job Details</h2>
      <div className="commonCntr">
        <form className="form-horizontal" method="POST" onSubmit={updatejob}>
          <div className="form-group">
            <label className="control-label col-sm-2 label">Title:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="title"
                id="title"
                defaultValue={items.title}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Description:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="desc"
                id="desc"
                defaultValue={items.description}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Creator Name:
            </label>
            <div className="col-sm-10 mt-1">
              <span>{items.creatorname}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Creator Email:
            </label>
            <div className="col-sm-10 mt-1">
              <span>{items.creatoremail}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              No. Of positions:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="positions"
                id="positions"
                defaultValue={items.no_position}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Date:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="date"
                className="form-control"
                name="date"
                id="date"
                defaultValue={items.date}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Time:
            </label>
            <div className="col-sm-4  mt-1">
              <input
                type="time"
                className="form-control"
                name="time"
                id="time"
                defaultValue={items.time}
              />
            </div>
          </div>
          
          {/* <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Specialism:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="specialism"
                id="specialism"
                defaultValue={items.specialism}
              />
            </div>
          </div> */}
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Information:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="informations"
                id="informations"
                defaultValue={items.informations}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">StartDate:</label>
            <DateTimePicker
              disableClock
              showIcon
              amPmAriaLabel={true}
              format={"y-MM-dd HH:mm:ss a"}
              value={startDate}
              // onChange={date=>setStartDate(date)}
              onChange={(date) => datefunction(date, "startdate")}
            />
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">EndDate:</label>
            <DateTimePicker
              disableClock
              amPmAriaLabel={true}
              format={"y-MM-dd HH:mm:ss a"}
              value={endDate}
              onChange={(date) => datefunction(date, "enddate")}
            />
          </div>
          {/* address */}
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">City:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="city"
                id="city"
                defaultValue={items.city}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Postcode:</label>
            <div className="col-sm-4  mt-1">
              <input
                type="text"
                className="form-control"
                name="postcode"
                id="postcode"
                defaultValue={items.postcode}
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Address:</label>
            <div className="col-sm-10  mt-1 mb-3">
              <span className="d-block">{items.address}</span>
            </div>
            <div className="mapCss col-sm-10">
              <SearchLocationInput setSelectedLocation={setSelectedLocation} />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Status:</label>
            {/* <div className="row"> */}
            <span>{selectedOption}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Industry:</label>
              <select multiple value={selectedOptions} onChange={handleChange}>
                {industries.map((option) => {
                  return (
                    <option value={option.id}>
                      {option.id}. {option.industry_name}
                    </option>
                  );
                })}
              </select>
          </div>

          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Skills:</label>
            <select multiple value={selectedOptionsCategory} onChange={handleChangeCategory}>
              {categoryList.map((option) => {
                  return (
                    <option value={option.id}>
                      {option.id}. {option.category_name}
                    </option>
                  )
                })}
            </select>
          </div>
          
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Sub Skills:</label>
            <select multiple value={selectedOptionsSubCategory} onChange={handleChangeSubCategory}>
              {subCategoryList.map((option) => {
                  return (
                    <option value={option.id}>
                      {option.id}. {option.subcategory_name}
                    </option>
                  )
                })}
            </select>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">
              Rejected Providers
            </label>
            <div className="col-sm-10 mt-1">
              {items.rejected_user_id
                ? items.rejected_user_id.map((e) => {
                    return (
                      <>
                        <span>
                          {e.name} - {e.email} - {e.status}
                        </span>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">
              Selected Providers
            </label>
            <div className="col-sm-10 mt-1">
              {items.selected_user_id
                ? items.selected_user_id.map((e) => {
                    return (
                      <>
                        <span>
                          {e.name} - {e.email} - {e.status}
                        </span>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">
              Creators Feedback
            </label>
            <div className="col-sm-10 mt-1">
              {feedbackCreator
                ? feedbackCreator.map((e, index) => {
                    return (
                      <>
                        <span>
                          {e.name} - {e.email} - {e.feedback}
                        </span>
                        <input
                          type="text"
                          key={index}
                          className="form-control"
                          name="city"
                          id={e.id}
                          defaultValue={e.feedback}
                          onChange={(event) => changeFeedback(event, e, index)}
                        />
                        {/* <button onClick={(event) => updateCreatorFeedback({
                          id: e.id,
                          feedback: e.feedback
                        })}>Update Feedback</button> */}
                        <br />
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-5 label">
              Provider Feedback
            </label>
            <div className="col-sm-10 mt-1">
              {feedbackProvider
                ? feedbackProvider.map((e, index) => {
                    return (
                      <>
                        <span>
                          {e.name} - {e.email} - {e.feedback}
                        </span>
                        <input
                          type="text"
                          key={index}
                          className="form-control"
                          name="city"
                          id={e.id}
                          defaultValue={e.feedback}
                          onChange={(event) => changeProviderFeedback(event, e, index)}
                        />
                        {/* <button onClick={(event) => updateCreatorFeedback({
                          id: e.id,
                          feedback: e.feedback
                        })}>Update Feedback</button> */}
                        <br />
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-10 label">Job Images uploaded by users</label>
            <div className="col-sm-4  mt-1">
            {items.jobImage ? (
              items.jobImage.map((e) => { 
                return <img
                src={e}
                class="img-fluid small-image"
                alt="No Document uploaded yet"
              />
                })) : <></>
              }
            </div>
          </div>
          {/* address */}
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-default submitBtn">
                Submit
              </button>
            </div>
          </div>
        </form>
        {successMessages.map((message, index) => (
          <SuccessMessage
            key={index}
            message={message}
            onFadeOut={handleSuccessMessageFadeOut}
          />
        ))}
      </div>
    </div>
  );
}

export default Jobupdate;
